import React from 'react';
import { MessageSquare, Workflow, Globe } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/canvaTranslations';

const ProblemSection = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  const problems = [
    {
      icon: <MessageSquare className="w-12 h-12" />,
      title: t.problem.channelMisalignment.title,
      description: t.problem.channelMisalignment.description,
      color: 'from-red-400 to-red-600',
    },
    {
      icon: <Workflow className="w-12 h-12" />,
      title: t.problem.fragmentedExperience.title,
      description: t.problem.fragmentedExperience.description,
      color: 'from-orange-400 to-orange-600',
    },
    {
      icon: <Globe className="w-12 h-12" />,
      title: t.problem.collaborationBarriers.title,
      description: t.problem.collaborationBarriers.description,
      color: 'from-yellow-400 to-yellow-600',
    },
  ];

  return (
    <section
      id="problem"
      className="min-h-screen py-24 bg-gradient-to-br from-gray-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.problem.title}
            <br />
            {t.problem.title2}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00C4CC] to-[#6C47FF] mx-auto rounded-full"></div>
          <p className="text-xl text-gray-600 mt-6 max-w-3xl mx-auto">
            {t.problem.description}
          </p>
        </div>

        {/* Problem Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Icon with Gradient Background */}
              <div className={`mb-6 w-20 h-20 rounded-2xl bg-gradient-to-br ${problem.color} flex items-center justify-center text-white shadow-lg transform group-hover:scale-110 transition-transform duration-300`}>
                {problem.icon}
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {problem.description}
              </p>

              {/* Decorative Element */}
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${problem.color} opacity-5 rounded-bl-full transform group-hover:opacity-10 transition-opacity duration-300`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
